import Button from "components/BaseWidgets/button";
import ExploreHeader from "../ExploreHeader";
import { useContext, useState } from "react";
import { ExploreContext } from "context/ExploreContext";
import { useEffect } from "react";

function ExploreLayout({
  children,
  title,
  description,
  count = "0",
  isListing,
  paginationDetails,
}) {
  const { setTabActive } = useContext(ExploreContext);
  const [totalPage, setTotalPage] = useState(0);

  useEffect(() => {
    if (paginationDetails) {
      const shownProfiles = Math.min(
        paginationDetails.limit * paginationDetails.page,
        paginationDetails.count,
      );
      setTotalPage(shownProfiles);
    }
  }, [paginationDetails]);

  return (
    <div className="flex flex-col gap-6 pl-10 pt-3 explore-layout">
      <div className="flex flex-col gap-3">
        {isListing && <Button isBack onClick={() => setTabActive("6")} />}
        <ExploreHeader
          title={title}
          description={description}
          totalProfiles={isListing ? count : totalPage}
          isContact={isListing}
        />
      </div>
      {children}
    </div>
  );
}

export default ExploreLayout;
